export default __webpack_public_path__ + "static/media/auctionThumb-1.ae1a5ed6.png";